import { defineMessages } from 'react-intl';

import { INTL_PREFIX } from '@/messages/const';

export const intlPrefix = `${INTL_PREFIX.PAYMENT}.smbc`;

export const defined = defineMessages({
  installmentInfo: {
    defaultMessage: 'Payment in installments with 0% interest possible with ',
    id: `${intlPrefix}.installmentInfo`,
  },
  installmentInfoCTA: {
    defaultMessage: 'Calculate financing with SUMITOMO MITSUI CARD.',
    id: `${intlPrefix}.installmentInfoCTA`,
  },
  loanAgreementAndPaymentOptionsPart1: {
    defaultMessage:
      'After your order is confirmed, you will need to complete the shopping loan agreement. You can choose the number of times you wish to pay.',
    id: `${intlPrefix}.loanAgreementAndPaymentOptionsPart1`,
  },
  loanAgreementAndPaymentOptionsPart2: {
    defaultMessage:
      'Number of installments: 0% interest rate is applied for 6, 10, 12, 15, 18, 20, 24, 30, 36,42,48,54 and 60 installments.',
    id: `${intlPrefix}.loanAgreementAndPaymentOptionsPart2`,
  },
  loanAgreementAndPaymentOptionsPart3: {
    defaultMessage: 'Not available to customers under 18 years of age.',
    id: `${intlPrefix}.loanAgreementAndPaymentOptionsPart3`,
  },
  loanAgreementAndPaymentOptionsPart4: {
    defaultMessage:
      'The delivery address and billing address must be the same as the address entered on the loan application.',
    id: `${intlPrefix}.loanAgreementAndPaymentOptionsPart4`,
  },
  loanAgreementAndPaymentOptionsPart5: {
    defaultMessage:
      'Orders will not be processed until Breitling confirms approval of the loan review. Delivery dates are subject to change.',
    id: `${intlPrefix}.loanAgreementAndPaymentOptionsPart5`,
  },
});
